import React from "react";
import { FilterProvider, useFilters } from "./components/FilterContext";
import LeftBar from "./components/LeftBar";
import './App.css';
import RightSection from "./components/RightSection";
import Loader from "./components/Loader";
import ListingSkeleton from "./components/ListingSkeleton";
import MobilePopup from "./components/MobilePopup";

function App() {
  return (
    <>
    <div className="category_container">
      <FilterProvider>
        <LeftBar />
        <RightSection />
        <Loader />
        <ListingSkeleton />
        <MobilePopup />
      </FilterProvider>
      </div>
    </>
  );
}

export default App;
